import { useAggregation } from "@ext/markdown/elements/table/edit/logic/aggregation";
import { memo, type RefObject } from "react";

export const AggregationTableRow = memo(({ tableRef }: { tableRef: RefObject<HTMLTableElement> }) => {
	const cells = useAggregation(tableRef);
	const hasSomeMethod = cells?.some((cell) => cell.method);

	if (!hasSomeMethod) return null;

	return (
		<tr contentEditable={false} data-aggregation="true">
			{cells?.map((cell) => (
				<td
					align={cell.align as "left" | "center" | "right"}
					colSpan={cell.colspan}
					contentEditable={false}
					data-aggregation={cell.method}
					key={cell.physicalIndex}
				>
					{cell.value}
				</td>
			))}
		</tr>
	);
});
